import type {
	MenuItemDivider,
	MenuItemLinks,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
	NavCta,
} from '@ds-mgnl/marketing';

export const topNavData: NavBarItem[] = [
	{
		type: 'submenu',
		label: 'Products',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: 'Shop by room',
						links: [
							{
								label: 'Bedroom',
								path: '/products/bedroom',
								value: '/products/bedroom',
								openInNewTab: false,
							},
							{
								label: 'Common Area',
								path: '/products/common-area',
								value: '/products/common-area',
								openInNewTab: false,
							},
							{
								label: 'Dining Room',
								path: '/products/dining-room',
								value: '/products/dining-room',
								openInNewTab: false,
							},
							{
								label: 'Office',
								path: '/products/office',
								value: '/products/office',
								openInNewTab: false,
							},
						],
					},
					{
						label: 'Shop by category',
						columnCount: 2,
						links: [
							{
								label: 'Benches & Ottomans',
								path: '/products/benches-ottomans',
								value: '/products/benches-ottomans',
								openInNewTab: false,
							},
							{
								label: 'Casegoods',
								path: '/products/casegoods',
								value: '/products/casegoods',
								openInNewTab: false,
							},
							{
								label: 'Chairs',
								path: '/products/chairs',
								value: '/products/chairs',
								openInNewTab: false,
							},
							{
								label: 'Desks',
								path: '/products/desks',
								value: '/products/desks',
								openInNewTab: false,
							},
							{
								label: 'Dining Seating',
								path: '/products/dining-seating',
								value: '/products/dining-seating',
								openInNewTab: false,
							},
							{
								label: 'Dining Tables',
								path: '/products/dining-tables',
								value: '/products/dining-tables',
								openInNewTab: false,
							},
							{
								label: 'Lighting',
								path: '/products/lighting',
								value: '/products/lighting',
								openInNewTab: false,
							},
							{
								label: 'Loveseats',
								path: '/products/loveseats',
								value: '/products/loveseats',
								openInNewTab: false,
							},
							{
								label: 'Motion Seating',
								path: '/products/motion-seating',
								value: '/products/motion-seating',
								openInNewTab: false,
							},
							{
								label: 'Occasional Tables',
								path: '/products/occasional-tables',
								value: '/products/occasional-tables',
								openInNewTab: false,
							},
							{
								label: 'Sofas',
								path: '/products/sofas',
								value: '/products/sofas',
								openInNewTab: false,
							},
							{
								label: 'Storage Cabinets',
								path: '/products/storage-cabinets',
								value: '/products/storage-cabinets',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
			{
				type: 'divider',
			} as MenuItemDivider,
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Shop all rooms',
								path: '/products',
								value: '/products',
								openInNewTab: false,
							},
						],
					},
					{
						label: '',
						links: [
							{
								label: 'Shop all categories',
								path: '/products',
								value: '/products',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Quick-Ship',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: 'Shop by room',
						links: [
							{
								label: 'Bedroom',
								path: '/quick-ship/bedroom',
								value: '/quick-ship/bedroom',
								openInNewTab: false,
							},
							{
								label: 'Common Area',
								path: '/quick-ship/common-area',
								value: '/quick-ship/common-area',
								openInNewTab: false,
							},
							{
								label: 'Dining Room',
								path: '/quick-ship/dining-room',
								value: '/quick-ship/dining-room',
								openInNewTab: false,
							},
						],
					},
					{
						label: 'Shop by category',
						columnCount: 2,
						links: [
							{
								label: 'Casegoods',
								path: '/quick-ship/casegoods',
								value: '/quick-ship/casegoods',
								openInNewTab: false,
							},
							{
								label: 'Chairs',
								path: '/quick-ship/chairs',
								value: '/quick-ship/chairs',
								openInNewTab: false,
							},
							{
								label: 'Dining Seating',
								path: '/quick-ship/dining-seating',
								value: '/quick-ship/dining-seating',
								openInNewTab: false,
							},
							{
								label: 'Dining Tables',
								path: '/quick-ship/dining-tables',
								value: '/quick-ship/dining-tables',
								openInNewTab: false,
							},
							{
								label: 'Loveseats',
								path: '/quick-ship/loveseats',
								value: '/quick-ship/loveseats',
								openInNewTab: false,
							},
							{
								label: 'Motion Seating',
								path: '/quick-ship/motion-seating',
								value: '/quick-ship/motion-seating',
								openInNewTab: false,
							},
							{
								label: 'Occasional Tables',
								path: '/quick-ship/occasional-tables',
								value: '/quick-ship/occasional-tables',
								openInNewTab: false,
							},
							{
								label: 'Sofas',
								path: '/quick-ship/sofas',
								value: '/quick-ship/sofas',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
			{
				type: 'divider',
			} as MenuItemDivider,
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Shop all rooms',
								path: '/quick-ship',
								value: '/quick-ship',
								openInNewTab: false,
							},
						],
					},
					{
						label: '',
						links: [
							{
								label: 'Shop all categories',
								path: '/quick-ship',
								value: '/quick-ship',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Fabrics',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Maxwell Thomas Fabrics',
								path: '/fabrics/maxwell-thomas',
								value: '/fabrics/maxwell-thomas',
								openInNewTab: false,
							},
							{
								label: 'Contracted Fabrics',
								path: '/fabrics/contracted',
								value: '/fabrics/contracted',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'link',
		link: {
			label: 'Finishes',
			path: '/finishes',
			value: '/finishes',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'link',
		link: {
			label: 'About Us',
			path: '/about',
			value: '/about',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'submenu',
		label: 'Resources',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Blogs',
								path: '/resources/blogs',
								value: '/resources/blogs',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
			{
				type: 'divider',
			} as MenuItemDivider,
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'View all resources',
								path: '/resources',
								value: '/resources',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
];

export const ctaLinks: NavCta[] = [
	{
		path: '/contact',
		label: 'Contact',
		value: '/contact',
		openInNewTab: false,
	},
];
